/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-props-no-spreading */
import React from "react";
import { withRouter } from "react-router";

import PropTypes from "prop-types";

import { defaultCurrency } from "../../../shared/constants/currency";
import styles from "./SmallProduct.module.css";

const getSuggestedPartProps = (brandRefreshSuggested, part) =>
  brandRefreshSuggested ? { "data-part": part } : {};

const SmallProduct = ({
  title,
  image,
  price,
  strikePrice,
  onAdd,
  icon,
  className,
  doughProOverlay,
  currency,
  categories,
  description,
  brandRefreshSuggested,
  isCrossSell
}) => {
  // Build accessible label: price, title, and categories/description
  const buildAccessibleLabel = () => {
    const parts = [];

    // Add price
    if (price) {
      const priceText = strikePrice
        ? `${currency.symbol}${price} (was ${currency.symbol}${strikePrice})`
        : `${currency.symbol}${price}`;
      parts.push(priceText);
    }

    // Add title
    parts.push(title);

    // Add categories if available
    if (categories && categories.length > 0) {
      const categoryNames = categories
        .map(cat => cat.name || cat.slug)
        .filter(Boolean)
        .join(" ");
      if (categoryNames) {
        parts.push(categoryNames);
      }
    }

    // Add description if available and no categories
    if (description && (!categories || categories.length === 0)) {
      parts.push(description);
    }

    return parts.join(" ");
  };

  const accessibleLabel = buildAccessibleLabel();

  const handleKeyDown = e => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      onAdd();
    }
  };

  const details = (
    <div
      className={styles.smallDetails}
      {...getSuggestedPartProps(brandRefreshSuggested, "cross-sell-details")}
    >
      {price ? (
        strikePrice ? (
          <span {...getSuggestedPartProps(brandRefreshSuggested, "cross-sell-price")}>
            <strike>{`${currency.symbol}${strikePrice}  `}</strike>
            &nbsp;
            {`${currency.symbol}${price}`}
          </span>
        ) : (
          <span {...getSuggestedPartProps(brandRefreshSuggested, "cross-sell-price")}>
            {`${currency.symbol}${price}`}
          </span>
        )
      ) : null}
      <h4 {...getSuggestedPartProps(brandRefreshSuggested, "cross-sell-name")}>{title}</h4>
      {doughProOverlay ? <h5>CookieMagic Member Exclusive</h5> : null}
    </div>
  );

  const action = (
    <div
      className={`
      dark:bg-button bg-dark rounded-full flex items-center justify-center
      text-dark dark:text-white
      ${styles.cartButton}`}
      aria-hidden="true"
      {...getSuggestedPartProps(brandRefreshSuggested, "cross-sell-action")}
    >
      <img alt="" src={icon} aria-hidden="true" />
    </div>
  );

  const photo = (
    <div
      className={styles.imageContainer}
      aria-hidden="true"
      {...getSuggestedPartProps(brandRefreshSuggested, "cross-sell-photo")}
    >
      <img
        alt=""
        src={image}
        className="product-main-image group-hover:scale-110 transition-all duration-300"
        aria-hidden="true"
      />
    </div>
  );
  const priceLabel = price ? `${currency.symbol}${price}` : null;

  // Brand refresh checkout Suggested items — Figma 3823:8850 horizontal cross-sell
  if (isCrossSell) {
    return (
      <button
        type="button"
        onClick={onAdd}
        onKeyDown={handleKeyDown}
        className={`${styles.crossSellCard} ${className}`}
        aria-label={accessibleLabel}
        data-part="cross-sell-card"
      >
        <div className={styles.crossSellPhoto} aria-hidden="true">
          <img alt="" src={image} className={styles.crossSellPhotoImg} />
        </div>
        <div className={styles.crossSellBody}>
          <div className={styles.crossSellDesc}>
            <span className={styles.crossSellTitle}>{title}</span>
            {strikePrice && price ? (
              <span className={styles.crossSellPrice}>
                <strike>{`${currency.symbol}${strikePrice}  `}</strike>
                &nbsp;
                {`${currency.symbol}${price}`}
              </span>
            ) : null}
            {!strikePrice && priceLabel ? (
              <span className={styles.crossSellPrice}>{priceLabel}</span>
            ) : null}
            {doughProOverlay ? (
              <span className={styles.crossSellExclusive}>
                CookieMagic Member Exclusive
              </span>
            ) : null}
          </div>
          <span className={styles.crossSellCta} aria-hidden="true">
            <img alt="" src={icon} width={16} height={16} />
          </span>
        </div>
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={onAdd}
      onKeyDown={handleKeyDown}
      className={`${styles.smallContainer} ${className} group`}
      aria-label={accessibleLabel}
      {...getSuggestedPartProps(brandRefreshSuggested, "cross-sell")}
    >
      {brandRefreshSuggested ? (
        <>
          {photo}
          <div {...getSuggestedPartProps(true, "cross-sell-content")}>
            {details}
            {action}
          </div>
        </>
      ) : (
        <>
          {action}
          {photo}
          {details}
        </>
      )}
    </button>
  );
};

SmallProduct.propTypes = {
  title: PropTypes.string.isRequired,
  image: PropTypes.node.isRequired,
  price: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  strikePrice: PropTypes.number,
  onAdd: PropTypes.func.isRequired,
  icon: PropTypes.node.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired,
  className: PropTypes.string.isRequired,
  doughProOverlay: PropTypes.bool,
  currency: PropTypes.objectOf(PropTypes.string),
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      slug: PropTypes.string
    })
  ),
  description: PropTypes.string,
  brandRefreshSuggested: PropTypes.bool,
  isCrossSell: PropTypes.bool
};

SmallProduct.defaultProps = {
  price: null,
  doughProOverlay: false,
  strikePrice: null,
  currency: defaultCurrency,
  categories: null,
  description: null,
  brandRefreshSuggested: false,
  isCrossSell: false
};

export default withRouter(SmallProduct);
